<template>
    <div class="p-col-12">
        <page-header title="forms.protocol.title"/>
        <form @submit.prevent="save">

            <card :header="$t('forms.protocol.card-information')" class="p-col-12" >
              <coff-input-text v-model="form.name" label="forms.protocol.name" class="p-col-12 p-md-6 p-lg-4" />
              <coff-input-text v-model="form.familyName" label="forms.protocol.family-name" class="p-col-12 p-md-6 p-lg-4" />
              <coff-input-select v-model="form.stage" label="forms.protocol.stage" class="p-col-12 p-md-6 p-lg-4" :options="stages" :error="validation.stage" />
              <coff-input-select v-model="form.typeService" label="forms.protocol.type-service" class="p-col-12 p-md-6 p-lg-4" :options="typeServices" :error="validation.typeService" />
              <coff-input-auto-complete v-model="form.mainClient" label="forms.protocol.main-client" class="p-col-11 p-md-5 p-lg-3" :itens="clients" field="name" :func-suggestions="searchClient" :error="validation.mainClient"/>
              <a class="cursor-pointer p-col-1 p-md-1 p-lg-1" @click.prevent="modalClientForm" style="margin-top: 30px;"><i class="pi pi-users" :title="$t('menu.client.form')"/></a>
              <coff-input-radio v-model="form.haveTax" @update="forceUpdateField('haveTax', $event)" :options="options" label="forms.protocol.have-tax" class="p-col-12 p-md-6 p-lg-4" :error="validation.haveTax"/>
              <coff-input-radio v-if="!form.id" v-model="form.budget" @update="forceUpdateField('budget', $event)" :options="options" label="forms.protocol.budget" class="p-col-12 p-md-6 p-lg-4" :error="validation.budget"/><i class=""></i>
              <coff-input-text v-model="form.publicAccessCode" label="forms.protocol.access-code" class="p-col-2 p-md-2 p-lg-2" :disable="true"/>
              <div class="p-col-1 p-md-1 p-lg-1 p-as-center p-mt-3">
                <a class="cursor-pointer" @click.prevent="generateAccessCode" style="margin-top: 30px;"><i class="fa fa-key" :title="$t('forms.protocol.generate-access-code')"/></a>
                <a class="cursor-pointer p-ml-3" @click.prevent="generateAccessLink" style="margin-top: 30px;"><i class="fa fa-link" :title="$t('forms.protocol.copy-access-link')"/></a>
              </div>
            </card>

            <div class="p-col-12">
                <Button :label="$t('btn.save')" class="p-button-success" style="float: right;"/>
            </div>
        </form>
    </div>
</template>

<script>

    import ValidationUtils from "@/utils/ValidationUtils";
    import ToastMessageBusiness from "@/business/ToastMessageBusiness";
    import EventBus from "@/commons/EventBus";
    import PageHeader from "@/components/page/PageHeader";
    import ClientBusiness from "@/business/ClientBusiness";
    import ProtocolBusiness from "@/business/ProtocolBusiness";
    import TypeServiceBusiness from "@/business/TypeServiceBusiness";
    import StageBusiness from "@/business/StageBusiness";
    import FrontBusiness from "@/business/FrontBusiness";
    import DialogService from "@/business/ModalBusiness";
    import ModalClientForm from "@/viewer/client/ModalClientForm";

    export default {
        name: "ProtocolForm",
        components: {PageHeader},

        data(){
            return {
                form: {},
                validation: {
                    stage: false,
                    typeService: false,
                    mainClient: false,
                    haveTax: false,
                    budget: false,
                },
                clients: [],
                stages: [],
                typeServices: [],
                options: [
                  {value: true, label: 'field.default.yes'},
                  {value: false, label: 'field.default.no'}
                ],
            }
        },
        async mounted(){
            const id = this.$route.params.id;
            this.clients =  await ClientBusiness.getAll();
            this.stages =  await StageBusiness.getAll();
            this.typeServices =  await TypeServiceBusiness.getAllActive();
            if(id){
                EventBus.loadingPage(true);
                this.form = {...await ProtocolBusiness.getById(id)};
                EventBus.loadingPage(false);
            }
        },
        methods:{

            async generateAccessLink(){
              let link = `${location.protocol}//${location.host}/#/public-client/${this.$route.params.id}`;
              await navigator.clipboard.writeText(link);
              ToastMessageBusiness.showSuccess("forms.protocol.link-coped-to-clipboard");
            },

            generateAccessCode(){
              const code = (Math.random() * 100000000).toString().replace('.', '').substring(0, 6);
              this.$set(this.form, 'publicAccessCode', code);
            },

            async save(){
                if(this.form.id) {
                  delete this.validation.budget;
                }
                this.validation = ValidationUtils.basicValidation(this.validation, this.form);
                if(!this.validation.erros){
                    const response = await ProtocolBusiness.save(this.form, this.form.id).catch((e) => ToastMessageBusiness.showError(e.message));
                    if(response){
                        this.form.id = response.id;
                        ToastMessageBusiness.showSuccess();
                        this.redirectToProtocolPage(this.form.id);
                    }
                }
            },

            async searchClient(name){
              return await ClientBusiness.search(name);
            },

            redirectToProtocolPage(protocolId){
              FrontBusiness.redirect(`/protocol/${protocolId}`);
            },

            forceUpdateField(field, value){
              this.$set(this.form, field, value);
            },

            async modalClientForm(){
              const client = await DialogService.openModal(ModalClientForm, {}, 1000);
              if(client){
                this.$set(this.form, 'mainClient', client);
              }
            }

        }
    }
</script>

<style scoped>

</style>
